import { useQuery } from '@apollo/client';

import { hasPermission } from '@/modules/auth/useAuth';
import { POS_CONFIG_QUERY } from '@/shared/graphql/system.gql';
import { useAuthStore } from '@/stores/authStore';

interface PosConfigResponse {
  posConfig: { single_station_mode_enabled: boolean };
}

/**
 * True only when the clinic-wide setting is on AND the current user holds both
 * pos.cashier.use and pos.doctor.use (typically via the seeded `front_desk_combined`
 * role) — mirrors the server-side gate in SaleOrdersService.assertSingleStationAllowed.
 * Polls so an admin flipping the setting mid-shift takes effect without a re-login.
 */
export function useSingleStationMode(): boolean {
  const { data } = useQuery<PosConfigResponse>(POS_CONFIG_QUERY, {
    fetchPolicy: 'cache-and-network',
    pollInterval: 60_000,
  });
  const permissions = useAuthStore((s) => s.user?.permissions ?? []);
  const flag_enabled = data?.posConfig.single_station_mode_enabled ?? false;
  const has_dual_role =
    hasPermission(permissions, 'pos.cashier.use') && hasPermission(permissions, 'pos.doctor.use');
  return flag_enabled && has_dual_role;
}
